import type { AxiosResponse } from 'axios';
import { useAuthContext } from 'contexts';
import React, { useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { Icon, Loader, Message, Popup } from 'semantic-ui-react';
import { connectGet } from 'services';

type AudioIconPopupZoomProps = {
  engagementId?: string;
  data?: string;
};

const AudioIconPopupZoom: React.FC<AudioIconPopupZoomProps> = ({ engagementId, data }) => {
  const [audioError, setAudioError] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [isUrlLoading, setIsUrlLoading] = useState(false);

  const { token } = useAuthContext();

  const openAudioURL = async () => {
    if (!engagementId) {
      setAudioError('Invalid contact ID.');
      return;
    }

    resetAudioState();
    setIsUrlLoading(true);

    try {
      let urlAudio: AxiosResponse<string> | null = null;

      const endpoint = '';

      if (endpoint) {
        urlAudio = await connectGet<string>(endpoint, token);
      }

      const recording = urlAudio?.data;
      setAudioUrl(recording!);

      if (!recording) {
        setAudioError('Audio recording could not be found.');
      }
    } catch (err) {
      setAudioError((err as { message?: string })?.message || 'An unexpected error occurred.');
    } finally {
      setIsUrlLoading(false);
    }
  };

  const resetAudioState = () => {
    setAudioError('');
    setAudioUrl('');
  };

  return (
    <>
      {engagementId && (
        <Popup
          trigger={
            <Icon onClick={openAudioURL} name="file audio" size="large" color="green" style={{ cursor: 'pointer' }} />
          }
          on="click"
        >
          <>
            {isUrlLoading && <Loader active inline content="Loading..." />}
            {audioUrl ? (
              <ReactAudioPlayer src={audioUrl} autoPlay controls />
            ) : (
              audioError && <Message content={audioError} error />
            )}
          </>
        </Popup>
      )}
      {data && <ReactAudioPlayer src={data} autoPlay controls />}
    </>
  );
};

export default AudioIconPopupZoom;
